import Vue from 'vue'
import Vuex from 'vuex'
import products from './modules/products'
import services from './modules/services'
import news from './modules/news'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 全局状态
    loading: false,
    error: null,
    userInfo: null
  },
  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    }
  },
  actions: {
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    },
    setError({ commit }, error) {
      commit('SET_ERROR', error)
    },
    clearError({ commit }) {
      commit('SET_ERROR', null)
    }
  },
  modules: {
    products,
    services,
    news
  }
})